import { UserReferral } from '@gamiphy/bl/referrals/types';
import { ReferralApi } from '@gamiphy/gamix-modules/referrals';
import {
  LinkReferralDto,
  LinkReferralsApi, ReferralDto, ReferralsApi, UserReferralsApi,
} from '@coretava/api/events-service';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import {
  computed, makeAutoObservable, observable, runInAction, when,
} from 'mobx';

class ReferralsStore {
  @observable initialized = false;

  @observable userReferrals?: UserReferral[] = [];

  @observable appReferral?: ReferralDto = undefined;

  @observable linkReferral?: LinkReferralDto = undefined;

  @computed
  get referralsApi(): ReferralsApi {
    return new ReferralsApi({
      isJsonMime(): boolean {
        return true;
      },
      basePath: process.env.BASE_API_URL,
      accessToken: UserStore.token,
    });
  }

  @computed
  get linkReferralsApi(): LinkReferralsApi {
    return new LinkReferralsApi({
      isJsonMime(): boolean {
        return true;
      },
      basePath: process.env.BASE_API_URL,
      accessToken: UserStore.token,
    });
  }

  @computed
  get userReferralsApi(): UserReferralsApi {
    return new UserReferralsApi({
      isJsonMime(): boolean {
        return true;
      },
      basePath: process.env.BASE_API_URL,
      accessToken: UserStore.token,
    });
  }

  constructor() {
    makeAutoObservable(this);

    when(() => AppStore.initialized && UserStore.isLoggedIn && !AppStore.isCashbackProgram, () => {
      void (async () => {
        const [
          userReferrals,
          referralsResponse,
        ] = await Promise.all([
          ReferralApi.getUserReferrals(),
          this.referralsApi.referralsControllerList(AppStore.app.id),
        ]);

        runInAction(() => {
          this.userReferrals = userReferrals;
          [this.appReferral] = referralsResponse.data.referrals;
        });

        if (this.appReferral) {
          const linkReferralResponse = await this.linkReferralsApi.linkReferralsControllerGet(AppStore.app.id, this.appReferral.id);

          runInAction(() => {
            this.linkReferral = linkReferralResponse.data.linkReferral;
          });
        }

        runInAction(() => {
          this.initialized = true;
        });
      })();
    });
  }
}

export default new ReferralsStore();
